import { Component, Input, OnInit } from '@angular/core';
import { MetadataAreaAbstract } from 'src/app/abstract/widgets/metadata-area.abstract';
import { ActionsEnum } from 'src/app/enums/permissions/actions.enum';
import { WidgetsFieldModel } from 'src/app/models/widgets/widgets-field.model';
import { PermissionsService } from 'src/app/services/auth/permissions.service';
import { alphaNumericInputValidator } from 'src/app/validators/alpha-numeric-input.validator';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { keyOverrideService } from 'src/app/services/workflow/keyOverrideService.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-metadata-field',
  templateUrl: './metadata-field.component.html',
  styleUrls: ['./metadata-field.component.scss']
})
export class MetadataFieldComponent extends MetadataAreaAbstract implements OnInit {
  @Input() data: WidgetsFieldModel = new WidgetsFieldModel();
  isEditKeysEnabled?: boolean;
  layoutRoot = this.widgetsService_.getLayoutRoot();
  constructor(private permissionsService: PermissionsService, private widgetsService_: WidgetsService, private keyOverrideService_:keyOverrideService, private router_:Router) {
    super();  
  }


  /**
   * will set fd key.
   * run on input field blur [ key replace dialog ]
   * @$event event parameter
   * **/ 
  runOnBlur_FdKey($event){ 
    this.keyOverrideService_.setkey(this.layoutRoot, $event.target.value,  this.data.key);
    this.widgetsService_.setLayoutRoot(this.layoutRoot);
  }

  isQuestionBuilderPage(){
    return this.router_.url.includes('question-editor');
  }

  ngOnInit(): void {
    if(this.data.key.includes('comment')){
      this.keyOverrideService_.isKeyOverWritePossible.next(false)
    } else{
      this.keyOverrideService_.isKeyOverWritePossible.next(true)
    }
      const allFormPrimitives:any = [];
      const root_:any = this.layoutRoot.children
      root_.forEach(sections=>{
      sections.children.forEach(question => {
          allFormPrimitives.push(...question.children)
        })
      })
      const findedPrimitive = allFormPrimitives.find(item=>item.key == this.data.key.split('_')[0])
        if(findedPrimitive){
          if(!this.keyOverrideService_.isDuplicatekeysInThisFrom(this.data.key)){
            this.keyOverrideService_.isKeyOverWritePossible.next(false)
            return;
        }
        if(findedPrimitive?.fdKey){
          this.data.fdKey =  findedPrimitive?.fdKey;
        }else if(findedPrimitive?.fd_key){
          this.data.fdKey =  findedPrimitive?.fd_key
        }
      }
    this.isEditKeysEnabled = this.permissionsService.hasUserPermission(ActionsEnum.editFieldKey) && this.data.isEdit;
  }


  keyPressAlphaNumeric(event) {
    alphaNumericInputValidator(event);
  }
}
